module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"mapButton":"Karte","satelliteButton":"Satellit","openDetailsLink":"Details anzeigen","buildingsInMapBounds":"{count} Liegenschaft | {count} Liegenschaften","resetMapButton":"Karte zurücksetzen"}}')
  delete Component.options._Ctor
}
